/* eslint-disable camelcase */
import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Cycle } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store";
import { withBaseModel } from "../extensions/with-base-model"
import SyncableModel from "../../database/SyncableModel"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import JalaAnalytic from "../../utils/jala-analytic"

const CycleStoreProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const CycleStoreModel = types
  .model("CycleStore")
  .props(CycleStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof CycleStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async storeToServer(data, afterPushCallback) {
      return self.storeModelToServer(Cycle, data, afterPushCallback);
    },
    async store(data) {
      const afterPushCallback = async (success: boolean, model: SyncableModel) => {
        if (!success) return;
        const { brood_stock_product_id } = data
        if (brood_stock_product_id)
          await self.axios.put(`/cycles/${model.getKey()}`, { brood_stock_product_id }).catch()
      }
      return this.storeToServer(data, afterPushCallback);
      // return self.storeModel(Cycle, data);
    },
    async updateToServer(model: SyncableModel, data) {
      const isClosing = !model.getAttribute('finished_at') && data.finished_at;
      return self.updateModelToServer(Cycle, model, data)
        .then((success) => {
          if (success && isClosing) JalaAnalytic.log('Mobile App: Close Cycle updated', data);
          else if (success) JalaAnalytic.log('Mobile: Setting Cycle updated');
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      return this.updateToServer(model, data);
      // return self.updateModel(Cycle, model, data);
    },
    async deleteFromServer(model: SyncableModel) {
      return self.deleteModelFromServer(Cycle, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile: detele cycle', model.toArray());
          return success;
        });
    },
    async delete(model: SyncableModel) {
      return this.deleteFromServer(model)
      // return self.deleteModel(Cycle, model);
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type CycleStoreType = Instance<typeof CycleStoreModel>
export interface CycleStore extends CycleStoreType {}
type CycleStoreSnapshotType = SnapshotOut<typeof CycleStoreModel>
export interface CycleStoreSnapshot extends CycleStoreSnapshotType {}
export const createCycleStoreDefaultModel = () => types.optional(CycleStoreModel, {})
